import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon/app-store-apple-f1f919205b.svg'
import _imports_1 from '../assets/icon/app-store-google-4d63c31a3e.svg'
import _imports_2 from '../assets/images/cross1.png'
import _imports_3 from '../assets/icon/christianity.svg'
import _imports_4 from '../assets/images/testimonial/parishioner/patrick-ogoo.jpeg'
import _imports_5 from '../assets/images/Vector11.png'
import _imports_6 from '../assets/images/testimonial/parishioner/femi-patrick.jpg'
import _imports_7 from '../assets/images/testimonial/parishioner/anonymous.png'
import _imports_8 from '../assets/images/testimonial/priest/martinos.jpeg'
import _imports_9 from '../assets/images/testimonial/priest/francis-anyawu.jpg'
import _imports_10 from '../assets/images/testimonial/parishioner/victoria-ahanotu.png'
import _imports_11 from '../assets/screenshot/Frame1.png'
import _imports_12 from '../assets/screenshot/Frame2.png'
import _imports_13 from '../assets/screenshot/Frame3.png'
import _imports_14 from '../assets/screenshot/Frame4.png'
import _imports_15 from '../assets/screenshot/Frame5.png'


const _withScopeId = n => (_pushScopeId("data-v-1d4dc40f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  class: "header-text",
  style: {"padding":"20px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Have your Church / Parish online", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, " ParishBulletin is a platform that helps you manage your Church/Parish from your smartphone or computer while giving members the opportunity to perform basic spiritual activities right from their phones. ", -1))
const _hoisted_5 = { class: "action" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Get Started")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Request Demo ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Explore Available Parishes ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right ml-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div style=\"position:absolute;width:100%;\" data-v-1d4dc40f><div style=\"display:flex;justify-content:center;\" data-v-1d4dc40f><a target=\"_blank\" class=\"mr-3\" href=\"https://apps.apple.com/us/app/id1517548701\" data-v-1d4dc40f><img src=\"" + _imports_0 + "\" class=\"playstore-image\" alt=\"Apple Store\" data-v-1d4dc40f></a><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=com.grandilo.parishbulletin\" data-v-1d4dc40f><img src=\"" + _imports_1 + "\" class=\"playstore-image\" alt=\"Google Play Store\" data-v-1d4dc40f></a></div></div>", 1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"top-icon\" data-v-1d4dc40f><div class=\"cross\" data-v-1d4dc40f></div><div class=\"cross\" data-v-1d4dc40f><img style=\"margin-top:20px;\" src=\"" + _imports_2 + "\" width=\"40\" alt=\"\" data-v-1d4dc40f></div></div><div class=\"parish\" data-v-1d4dc40f><h2 class=\"parish-rep-header\" data-v-1d4dc40f>For Churches and Parishes</h2></div><div class=\"feature-container\" style=\"display:flex;flex-wrap:wrap;justify-content:center;\" data-v-1d4dc40f><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M28.72 24C28.88 22.68 29 21.36 29 20C29 18.64 28.88 17.32 28.72 16H35.48C35.8 17.28 36 18.62 36 20C36 21.38 35.8 22.72 35.48 24H28.72ZM25.18 35.12C26.38 32.9 27.3 30.5 27.94 28H33.84C31.92 31.3 28.86 33.86 25.18 35.12ZM24.68 24H15.32C15.12 22.68 15 21.36 15 20C15 18.64 15.12 17.3 15.32 16H24.68C24.86 17.3 25 18.64 25 20C25 21.36 24.86 22.68 24.68 24ZM20 35.92C18.34 33.52 17 30.86 16.18 28H23.82C23 30.86 21.66 33.52 20 35.92ZM12 12H6.16C8.06 8.68 11.14 6.12 14.8 4.88C13.6 7.1 12.7 9.5 12 12ZM6.16 28H12C12.7 30.5 13.6 32.9 14.8 35.12C11.14 33.86 8.06 31.3 6.16 28ZM4.52 24C4.2 22.72 4 21.38 4 20C4 18.62 4.2 17.28 4.52 16H11.28C11.12 17.32 11 18.64 11 20C11 21.36 11.12 22.68 11.28 24H4.52ZM20 4.06C21.66 6.46 23 9.14 23.82 12H16.18C17 9.14 18.34 6.46 20 4.06ZM33.84 12H27.94C27.3 9.5 26.38 7.1 25.18 4.88C28.86 6.14 31.92 8.68 33.84 12ZM20 0C8.94 0 0 9 0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C7.71504 35.9993 9.91982 37.4725 12.3463 38.4776C14.7728 39.4827 17.3736 40 20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 17.3736 39.4827 14.7728 38.4776 12.3463C37.4725 9.91982 35.9993 7.71504 34.1421 5.85786C32.285 4.00069 30.0802 2.5275 27.6537 1.52241C25.2272 0.517315 22.6264 0 20 0Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>Easiest Way To Take Your Church or Parish Online</h3><p data-v-1d4dc40f> Make your Church or Parish visible to the public. The world is now a Global village with Technology. Your Church should not be left behind </p></div></div></div></div><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"36\" height=\"24\" viewBox=\"0 0 36 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M0 0H36V24H0V0ZM18 6C19.5913 6 21.1174 6.63214 22.2426 7.75736C23.3679 8.88258 24 10.4087 24 12C24 13.5913 23.3679 15.1174 22.2426 16.2426C21.1174 17.3679 19.5913 18 18 18C16.4087 18 14.8826 17.3679 13.7574 16.2426C12.6321 15.1174 12 13.5913 12 12C12 10.4087 12.6321 8.88258 13.7574 7.75736C14.8826 6.63214 16.4087 6 18 6ZM8 4C8 5.06087 7.57857 6.07828 6.82843 6.82843C6.07828 7.57857 5.06087 8 4 8V16C5.06087 16 6.07828 16.4214 6.82843 17.1716C7.57857 17.9217 8 18.9391 8 20H28C28 18.9391 28.4214 17.9217 29.1716 17.1716C29.9217 16.4214 30.9391 16 32 16V8C30.9391 8 29.9217 7.57857 29.1716 6.82843C28.4214 6.07828 28 5.06087 28 4H8Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>No More Huge Expenditure In Printing Paper Bulletin</h3><p data-v-1d4dc40f> Subscribe to ParishBulletin and cut down your bulletin printing cost by 85%. Doubt it? Let&#39;s talk. </p></div></div></div></div><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"38\" height=\"37\" viewBox=\"0 0 38 37\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M16 0C24.84 0 32 3.58 32 8C32 12.42 24.84 16 16 16C7.16 16 0 12.42 0 8C0 3.58 7.16 0 16 0ZM0 12C0 16.42 7.16 20 16 20C24.84 20 32 16.42 32 12V18.16L30 18C24.82 18 20.4 21.28 18.72 25.88L16 26C7.16 26 0 22.42 0 18V12ZM0 22C0 26.42 7.16 30 16 30H18C18 32.1 18.54 34.08 19.5 35.8L16 36C7.16 36 0 32.42 0 28V22ZM28 36.16L22.5 30.16L24.82 27.84L28 31L35.18 23.84L37.5 26.66L28 36.16Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>An Organised Data Of Your Church members</h3><p data-v-1d4dc40f> You do not have to struggle again to get your Church members information. ParishBulletin infrastructure brings these data in an organized way right on your palm: your smartphone or computer </p></div></div></div></div><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M18 24H14C14 14.06 22.06 6 32 6V10C24.26 10 18 16.26 18 24ZM32 18V14C26.48 14 22 18.48 22 24H26C26 20.68 28.68 18 32 18ZM10 4C10 1.78 8.22 0 6 0C3.78 0 2 1.78 2 4C2 6.22 3.78 8 6 8C8.22 8 10 6.22 10 4ZM18.9 5H14.9C14.42 7.84 12 10 9 10H3C1.34 10 0 11.34 0 13V18H12V13.48C15.72 12.3 18.5 9 18.9 5ZM34 30C36.22 30 38 28.22 38 26C38 23.78 36.22 22 34 22C31.78 22 30 23.78 30 26C30 28.22 31.78 30 34 30ZM37 32H31C28 32 25.58 29.84 25.1 27H21.1C21.5 31 24.28 34.3 28 35.48V40H40V35C40 33.34 38.66 32 37 32Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>Easy Communication</h3><p data-v-1d4dc40f> Easily disseminate information to your Parishioners with less hassle. The information will reach them even with no internet. Want us to show you how? Request a demo </p></div></div></div></div></div>", 3)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"parish\" data-v-1d4dc40f><h2 data-v-1d4dc40f>For Parishioners</h2></div><div class=\"feature-container mt-5\" style=\"display:flex;flex-wrap:wrap;justify-content:center;\" data-v-1d4dc40f><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"44\" height=\"43\" viewBox=\"0 0 44 43\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M7.40169 17.6974L22.8076 12.3L10.4038 20.9686L7.40169 17.6974ZM30.2452 20.4045L23.548 35.2914L20.5459 32.0202L30.2452 20.4045ZM0.357178 15.9371L9.82319 26.2519L34.6309 8.91468L15.2323 32.1461L24.6984 42.4608L43.4721 0.800951L0.357178 15.9371Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>Your Parish Everywhere You Go</h3><p data-v-1d4dc40f> You don&#39;t have to wait till Sunday to know the latest thing happening in your Parish. </p></div></div></div></div><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"32\" height=\"42\" viewBox=\"0 0 32 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M16 0C22.62 0 28 5.32 28 11.9C28 20.82 16 34 16 34C16 34 4 20.82 4 11.9C4 5.32 9.38 0 16 0ZM16 8C14.9391 8 13.9217 8.42143 13.1716 9.17157C12.4214 9.92172 12 10.9391 12 12C12 13.0609 12.4214 14.0783 13.1716 14.8284C13.9217 15.5786 14.9391 16 16 16C17.0609 16 18.0783 15.5786 18.8284 14.8284C19.5786 14.0783 20 13.0609 20 12C20 10.9391 19.5786 9.92172 18.8284 9.17157C18.0783 8.42143 17.0609 8 16 8ZM32 34C32 38.42 24.84 42 16 42C7.16 42 0 38.42 0 34C0 31.42 2.44 29.12 6.22 27.66L7.5 29.48C5.34 30.38 4 31.62 4 33C4 35.76 9.38 38 16 38C22.62 38 28 35.76 28 33C28 31.62 26.66 30.38 24.5 29.48L25.78 27.66C29.56 29.12 32 31.42 32 34Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>Nearby Catholic Church</h3><p data-v-1d4dc40f> Easily locate a nearby Catholic church. ParishBulletin currently has over 460 registered Parishes. </p></div></div></div></div><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"44\" height=\"34\" viewBox=\"0 0 44 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M33 19.66C34.58 19.66 36.26 19.82 38 20.14V23.14C36.76 22.82 35.08 22.66 33 22.66C29.2 22.66 26.22 23.32 24 24.64V21.26C26.34 20.2 29.34 19.66 33 19.66ZM24 15.92C26.58 14.86 29.58 14.34 33 14.34C34.58 14.34 36.26 14.48 38 14.8V17.8C36.76 17.48 35.08 17.32 33 17.32C29.2 17.32 26.22 18 24 19.3V15.92ZM33 12C29.2 12 26.22 12.64 24 14V10.68C26.46 9.56 29.46 9 33 9C34.58 9 36.26 9.16 38 9.46V12.56C36.52 12.18 34.82 12 33 12ZM40 28V5C37.92 4.34 35.58 4 33 4C28.9 4 25.24 5 22 7V30C25.24 28 28.9 27 33 27C35.38 27 37.72 27.32 40 28ZM33 0C37.7 0 41.38 1 44 3V32.12C44 32.36 43.9 32.6 43.68 32.82C43.46 33 43.22 33.16 43 33.16C42.78 33.16 42.62 33.12 42.5 33.06C39.94 31.68 36.76 31 33 31C28.9 31 25.24 32 22 34C19.32 32 15.66 31 11 31C7.68 31 4.5 31.72 1.5 33.14C1.44 33.16 1.36 33.16 1.26 33.2C1.18 33.22 1.1 33.24 1 33.24C0.78 33.24 0.54 33.16 0.32 33C0.0999999 32.78 0 32.56 0 32.3V3C2.68 1 6.36 0 11 0C15.66 0 19.32 1 22 3C24.68 1 28.34 0 33 0Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>Devotion Prayers</h3><p data-v-1d4dc40f> Still struggling recition some prayers? ParishBulletin has a large catalog of prayers just for you. </p></div></div></div></div><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"36\" height=\"40\" viewBox=\"0 0 36 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M32 4H30V0H26V4H10V0H6V4H4C1.78 4 0 5.78 0 8V36C0 38.2 1.78 40 4 40H32C34.2 40 36 38.2 36 36V8C36 5.78 34.2 4 32 4ZM32 36H4V14H32V36ZM18 32V28H10V22H18V18L26 25L18 32Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>Book appointment with your Pastor or Priest</h3><p data-v-1d4dc40f> Booking an appointment with a Pastor has never been easier. Just book from Parishbulletin app and the Pastor will be waiting to attend to you at the scheduled time </p></div></div></div></div><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"36\" height=\"40\" viewBox=\"0 0 36 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M30.9998 20C36.5198 20 40.9998 15.52 40.9998 10C40.9998 4.48 36.5198 0 30.9998 0C25.4798 0 20.9998 4.48 20.9998 10C20.9998 15.52 25.4798 20 30.9998 20ZM41.8998 31.2C41.1198 30.4 40.1398 30 38.9998 30H24.9998L20.8398 28.54L21.4998 26.66L24.9998 28H30.5998C31.2998 28 31.8598 27.72 32.3198 27.26C32.7798 26.8 32.9998 26.24 32.9998 25.62C32.9998 24.54 32.4798 23.8 31.4398 23.38L16.8998 18H12.9998V36L26.9998 40L43.0598 34C43.0798 32.94 42.6798 32 41.8998 31.2ZM8.99977 18H0.967773V40H8.99977V18Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>Make and track your donations</h3><p data-v-1d4dc40f>Ranging from harvest, Tithe, church building, etc</p></div></div></div></div><div class=\"col-md-5 features\" data-v-1d4dc40f><div class=\"row\" data-v-1d4dc40f><div class=\"col-2\" data-v-1d4dc40f><div class=\"mt-3\" data-v-1d4dc40f><svg width=\"30\" height=\"47\" viewBox=\"0 0 24 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1d4dc40f><path d=\"M8 34H14V40H8V34ZM12 0C22.7 0.44 27.36 11.24 21 19.34C19.34 21.34 16.66 22.66 15.34 24.34C14 26 14 28 14 30H8C8 26.66 8 23.84 9.34 21.84C10.66 19.84 13.34 18.66 15 17.34C19.84 12.86 18.64 6.52 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12H0C0 8.8174 1.26428 5.76515 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0Z\" fill=\"#009688\" data-v-1d4dc40f></path></svg></div></div><div class=\"col-10\" data-v-1d4dc40f><div class=\"t-box\" data-v-1d4dc40f><h3 data-v-1d4dc40f>Questions And Answers</h3><p data-v-1d4dc40f> Have confusing question about the Christian faith? You can now get answers from expert apologist on ParishBulletin. </p></div></div></div></div></div><button class=\"request1\" data-v-1d4dc40f>Download Now</button><div class=\"download1\" style=\"display:flex;justify-content:center;margin-bottom:70px;margin-top:30px;\" data-v-1d4dc40f><a target=\"_blank\" class=\"mr-3\" href=\"https://apps.apple.com/us/app/id1517548701\" data-v-1d4dc40f><img src=\"" + _imports_0 + "\" class=\"playstore-image\" alt=\"\" data-v-1d4dc40f></a><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=com.grandilo.parishbulletin\" data-v-1d4dc40f><img src=\"" + _imports_1 + "\" class=\"playstore-image\" alt=\"\" data-v-1d4dc40f></a></div><div class=\"container left\" data-v-1d4dc40f></div><div class=\"container right\" data-v-1d4dc40f></div><div class=\"container feature-box\" data-v-1d4dc40f><div class=\"image1 top mt-4\" data-v-1d4dc40f></div><div class=\"feature\" data-v-1d4dc40f><h1 data-v-1d4dc40f>How it works<br data-v-1d4dc40f>(For Parishioners)</h1><ul data-v-1d4dc40f><li data-v-1d4dc40f>Download the app from Google Play or Apple store</li><li data-v-1d4dc40f>Select your Parish</li><li data-v-1d4dc40f>Sign up</li></ul><div class=\"download-btn\" data-v-1d4dc40f><a target=\"_blank\" class=\"mr-3\" href=\"https://apps.apple.com/us/app/id1517548701\" data-v-1d4dc40f><img src=\"" + _imports_0 + "\" style=\"height:32.94px;width:108px;\" alt=\"\" data-v-1d4dc40f></a><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=com.grandilo.parishbulletin\" data-v-1d4dc40f><img src=\"" + _imports_1 + "\" style=\"height:32.94px;width:108px;\" alt=\"\" data-v-1d4dc40f></a></div><a target=\"_blank\" href=\"https://apps.apple.com/us/app/id1517548701\" class=\"button2 alt\" data-v-1d4dc40f>Download Now</a></div><div class=\"image1 mt-4\" data-v-1d4dc40f></div></div><div class=\"polygon\" style=\"margin-top:-20px;margin-bottom:-20px;\" data-v-1d4dc40f><img style=\"margin-top:12px;margin-left:13px;transform:rotate(20deg);\" src=\"" + _imports_3 + "\" width=\"30\" alt=\"\" data-v-1d4dc40f></div>", 8)
const _hoisted_22 = { class: "container feature-box" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image2" }, null, -1))
const _hoisted_24 = { class: "feature" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("How it works"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(For Parish Representatives)")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Onboarding your parish is as simple as clicking on Get started button below "),
  /*#__PURE__*/_createElementVNode("li", null, " After filling the form we will review your Parish and revert back to you in the next 48hrs "),
  /*#__PURE__*/_createElementVNode("li", null, " If you do not hear from us in 48hrs then probably something went wrong. Send us an email via admin@parishbulletin.org ")
], -1))
const _hoisted_27 = {
  class: "buttons",
  style: {"display":"flex"}
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Get started")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Book a Demo")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "parish mt-5",
  style: {"width":"70%","margin":"auto"}
}, [
  /*#__PURE__*/_createElementVNode("h2", null, "What Parishioners Are Saying")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-top row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-image col-md-6" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_4,
        alt: "",
        class: "card-img"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card-header-title col-md-6" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Patrick Ogo"),
      /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-text" }, [
    /*#__PURE__*/_createElementVNode("p", null, " “Awesome , just Awesome . Well done to the developers. Kindly let us know how we can support this laudable initiative. Patrick from Benin City, Edo State” ")
  ])
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-top row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-image col-md-6" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_6,
        alt: "",
        class: "card-img"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card-header-title col-md-6" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Femi Patrick Oyedoyin"),
      /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-text" }, [
    /*#__PURE__*/_createElementVNode("p", null, " “Very good application. Kudos to the developers, Bravo!” ")
  ])
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-top row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-image col-md-6" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_7,
        alt: "",
        class: "card-img"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card-header-title col-md-6" }, [
      /*#__PURE__*/_createElementVNode("h2", null, " Google Play User"),
      /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-text" }, [
    /*#__PURE__*/_createElementVNode("p", null, " “I just became a Catholic last year. The app has been helping me to learn some Catholic Prayers” ")
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parish" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "What Priests Are Saying")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card",
  style: {"background-color":"#f5f5f5"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-top row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-image col-md-6" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_8,
        alt: "",
        class: "card-img"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card-header-title col-md-6" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Rev. Fr. Martinos Theodore"),
      /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-text" }, [
    /*#__PURE__*/_createElementVNode("p", null, " “I have been wanting to have a platform like this for past few year. It's a welcomed initiative” ")
  ])
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card",
  style: {"background-color":"#f5f5f5"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-top row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-image col-md-6" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_9,
        alt: "",
        class: "card-img"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card-header-title col-md-6" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Very Rev. Fr. Francis Anyanwu(Dean)"),
      /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-text" }, [
    /*#__PURE__*/_createElementVNode("p", null, " “I needed an app, i can use to reach out to my Parishioner's at any time. ParishBulletin gave that to me” ")
  ])
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card",
  style: {"background-color":"#f5f5f5"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-top row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-image col-md-6" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_10,
        alt: "",
        class: "card-img"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card-header-title col-md-6" }, [
      /*#__PURE__*/_createElementVNode("h2", null, " Victoria Ahanotu(Parish Secretary)"),
      /*#__PURE__*/_createElementVNode("div", { class: "rating" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        }),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "10",
          alt: ""
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-text" }, [
    /*#__PURE__*/_createElementVNode("p", null, " “ParishBulletin admin dashboard has really made my work easy in the office. I no longer have to sort through thousands of papers when looking for a parishioner's record.” ")
  ])
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parish" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "SCREENSHOTS"),
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"14px","margin-top":"-10px"} }, " some screens from our awesome app ")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  width: "210",
  alt: ""
}, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  width: "210",
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  width: "210",
  alt: ""
}, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  width: "210",
  alt: ""
}, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  width: "210",
  alt: ""
}, null, -1))
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"available\" data-v-1d4dc40f><h2 data-v-1d4dc40f>Available On</h2><a target=\"_blank\" class=\"mr-4\" href=\"https://apps.apple.com/us/app/id1517548701\" data-v-1d4dc40f><img src=\"" + _imports_0 + "\" class=\"playstore-image\" alt=\"\" data-v-1d4dc40f></a><a target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=com.grandilo.parishbulletin\" data-v-1d4dc40f><img src=\"" + _imports_1 + "\" class=\"playstore-image\" alt=\"\" data-v-1d4dc40f></a></div><div class=\"et\" data-v-1d4dc40f><img src=\"" + _imports_2 + "\" width=\"50\" alt=\"\" data-v-1d4dc40f></div>", 2)
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade",
  style: {"width":"100%","margin":"auto"},
  id: "video",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "videoModalLabel",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-dialog-centered modal-md",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "modal-content",
      style: {"width":"790px","margin":"auto","padding":"18px"}
    }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("span", {
          class: "close",
          style: {"cursor":"pointer"},
          "data-dismiss": "modal",
          "aria-label": "Close"
        }, [
          /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("iframe", {
          style: {"width":"100%"},
          width: "560",
          height: "315",
          src: "https://www.youtube.com/embed/pOC396p3_qc",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write;\n                encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        }, "\n            ")
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: {name: 'OnboardParish'},
            class: "btns"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/bookdemo",
            class: "btns"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_router_link, {
        to: "/parishes",
        class: "btns12"
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      }),
      _hoisted_10
    ]),
    _hoisted_11,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push('/bookdemo')), ["prevent"])),
      class: "request"
    }, "Request Demo"),
    _hoisted_14,
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_router_link, {
            to: {name: 'OnboardParish'},
            class: "button"
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/bookdemo",
            class: "button2"
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_30,
    _createVNode(_component_swiper, {
      spaceBetween: 10,
      loop: true,
      autoplay: { delay: 2000, disableOnInteraction: false },
      loopFillGroupWithBlank: true,
      pagination: {
        clickable: true,
      },
      navigation: true,
      modules: _ctx.modules,
      breakpoints: {
        1024: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 1,
        },
      },
      class: "container myswiper"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_swiper_slide, { class: "swiper-slide" }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }),
        _createVNode(_component_swiper_slide, { class: "swiper-slide" }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        }),
        _createVNode(_component_swiper_slide, { class: "swiper-slide" }, {
          default: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modules"]),
    _hoisted_34,
    _createVNode(_component_swiper, {
      spaceBetween: 5,
      loop: true,
      autoplay: { delay: 2000, disableOnInteraction: false },
      loopFillGroupWithBlank: true,
      pagination: {
        clickable: true,
      },
      navigation: true,
      modules: _ctx.modules,
      breakpoints: {
        1024: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 1,
        },
      },
      class: "container myswiper"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_swiper_slide, { class: "swiper-slide" }, {
          default: _withCtx(() => [
            _hoisted_35
          ]),
          _: 1
        }),
        _createVNode(_component_swiper_slide, null, {
          default: _withCtx(() => [
            _hoisted_36
          ]),
          _: 1
        }),
        _createVNode(_component_swiper_slide, { class: "swiper-slide" }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modules"]),
    _hoisted_38,
    _createVNode(_component_swiper, {
      slidesPerView: 3.5 / 2,
      spaceBetween: 30,
      autoplay: { delay: 2000, disableOnInteraction: false },
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      pagination: {
        clickable: true,
      },
      modules: _ctx.modules,
      breakpoints: {
        1280: {
          slidesPerView: 5,
          centeredSlides: false,
          spaceBetween: -90,
          pagination: {
            clickable: false,
          },
        },
        1020: {
          slidesPerView: 5,
          centeredSlides: false,
          spaceBetween: -80,
          pagination: {
            clickable: false,
          },
        },
        763: {
          slidesPerView: 3,
          spaceBetween: -100,
          centeredSlides: false,
        },
        540: {
          spaceBetween: -70,
        },
      },
      class: "screenshot1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_swiper_slide, { class: "mb-2" }, {
          default: _withCtx(() => [
            _hoisted_39
          ]),
          _: 1
        }),
        _createVNode(_component_swiper_slide, { class: "mb-2" }, {
          default: _withCtx(() => [
            _hoisted_40
          ]),
          _: 1
        }),
        _createVNode(_component_swiper_slide, { class: "mb-2" }, {
          default: _withCtx(() => [
            _hoisted_41
          ]),
          _: 1
        }),
        _createVNode(_component_swiper_slide, { class: "mb-2" }, {
          default: _withCtx(() => [
            _hoisted_42
          ]),
          _: 1
        }),
        _createVNode(_component_swiper_slide, { class: "" }, {
          default: _withCtx(() => [
            _hoisted_43
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["slidesPerView", "modules"]),
    _hoisted_44,
    _hoisted_46,
    _createVNode(_component_Footer)
  ]))
}